import React, { useEffect, useState } from 'react';

import relativity2401 from '../../../Assets/Linkages/CapacityBuilding/Events/relativity-2024/01.jpg';
import relativity2402 from '../../../Assets/Linkages/CapacityBuilding/Events/relativity-2024/02.jpg';
import relativity2403 from '../../../Assets/Linkages/CapacityBuilding/Events/relativity-2024/03.jpg';
import gis01 from '../../../Assets/Linkages/CapacityBuilding/Events/gis-summit-2024/01.jpg';
import gis02 from '../../../Assets/Linkages/CapacityBuilding/Events/gis-summit-2024/02.jpg';
import gis03 from '../../../Assets/Linkages/CapacityBuilding/Events/gis-summit-2024/03.jpg';
import law01 from '../../../Assets/Linkages/CapacityBuilding/Events/space-law-2024/01.jpg';
import law02 from '../../../Assets/Linkages/CapacityBuilding/Events/space-law-2024/02.jpg';
import law03 from '../../../Assets/Linkages/CapacityBuilding/Events/space-law-2024/03.jpg';
import geology01 from '../../../Assets/Linkages/CapacityBuilding/Events/geological-rs-2024/01.jpg';
import geology02 from '../../../Assets/Linkages/CapacityBuilding/Events/geological-rs-2024/02.jpg';
import geology03 from '../../../Assets/Linkages/CapacityBuilding/Events/geological-rs-2024/03.jpg';
import symposium01 from '../../../Assets/Linkages/CapacityBuilding/Events/space-symposium-2024/01.jpg';
import symposium02 from '../../../Assets/Linkages/CapacityBuilding/Events/space-symposium-2024/02.jpg';
import symposium03 from '../../../Assets/Linkages/CapacityBuilding/Events/space-symposium-2024/03.jpg';
import relativity2301 from '../../../Assets/Linkages/CapacityBuilding/Events/relativity-2023/01.jpg';
import relativity2302 from '../../../Assets/Linkages/CapacityBuilding/Events/relativity-2023/02.jpg';
import relativity2303 from '../../../Assets/Linkages/CapacityBuilding/Events/relativity-2023/03.jpg';
import remote01 from '../../../Assets/Linkages/CapacityBuilding/Events/remote-sensing-2023/01.jpg';
import remote02 from '../../../Assets/Linkages/CapacityBuilding/Events/remote-sensing-2023/02.jpg';
import remote03 from '../../../Assets/Linkages/CapacityBuilding/Events/remote-sensing-2023/03.jpg';
import aprsaf01 from '../../../Assets/Linkages/CapacityBuilding/Events/aprsaf-2023/01.jpg';
import aprsaf02 from '../../../Assets/Linkages/CapacityBuilding/Events/aprsaf-2023/02.jpg';
import aprsaf03 from '../../../Assets/Linkages/CapacityBuilding/Events/aprsaf-2023/03.jpg';
import teachers01 from '../../../Assets/Linkages/CapacityBuilding/Events/teachers-2023/01.jpg';
import teachers02 from '../../../Assets/Linkages/CapacityBuilding/Events/teachers-2023/02.jpg';
import teachers03 from '../../../Assets/Linkages/CapacityBuilding/Events/teachers-2023/03.jpg';

const events = [
  {
    year: '2024',
    title: '2nd Workshop on General Relativity, Cosmology, Astrophysics & Particle Physics',
    images: [relativity2401, relativity2402, relativity2403],
    paragraphs: [
      'The Space and Astrophysics Research Lab (SARL) of the National Center of GIS and Space Applications (NCGSA) organized the 2nd Workshop on General Relativity, Cosmology, Astrophysics, and Particle Physics on December 12, 2024, at the Institute of Space Technology (IST), Islamabad.',
      'The workshop brought together over 80 students, researchers, and professionals from across Pakistan. The program featured engaging lectures by eminent professors and domain experts, offering deep insights into cutting-edge topics in astronomy, astrophysics, and cosmology, and fostering intellectual exchange on some of the most profound questions in modern science.',
    ],
  },
  {
    year: '2024',
    title: 'National GIS Summit 2024',
    images: [gis01, gis02, gis03],
    paragraphs: [
      'The National Center of GIS and Space Applications (NCGSA) successfully hosted the National GIS Summit 2024 on November 20, 2024, at the Institute of Space Technology (IST), Islamabad, to commemorate International GIS Day. The summit brought together a diverse audience of experts, professionals, and students from across Pakistan to explore the transformative role of geospatial technologies in advancing sustainable development.',
      'The program featured thematic sessions on geospatial solutions for sustainable development, GIS for agriculture and food security, climate change mitigation, disaster preparedness, geo-health, geo-forensics, and the integration of artificial intelligence in GIS applications.',
    ],
  },
  {
    year: '2024',
    title: 'Workshop on Space Law and Policy 2024',
    images: [law01, law02, law03],
    paragraphs: [
      'The National Center of GIS and Space Applications (NCGSA) successfully hosted a two-day Workshop on Space Law and Policy from September 3–4, 2024, at the Institute of Space Technology (IST), Islamabad. The event brought together over 60 participants from academia, public institutions, and private organizations, fostering informed dialogue on the legal and regulatory dimensions of outer space activities.',
      'Key topics included space law and international treaties, space governance and diplomacy, regional and international cooperation, cybersecurity, space sustainability, and Pakistan’s National Space Policy. The workshop fostered insightful discussions on space governance, marking a significant step in advancing legal and policy frameworks for Pakistan’s growing space sector.',
    ],
    experts: [
      'Hamza Hameed — Senior Practice Manager, Access Partnership, Singapore',
      'Muhammad Arham Khan — Divisional Head, International Affairs, SUPARCO',
      'Dr. Maria Saifuddin Effendi — Assistant Professor, National Defence University',
      'Muhammad Naveed Hafiz — General Manager, International Affairs, SUPARCO',
      'Ms. Aisha Jagirani — Director General, APSCO',
      'Dr. Ammar Masood — Dean, Faculty of Computing & AI, Air University',
    ],
  },
  {
    year: '2024',
    title: 'International Workshop on Geological Remote Sensing & Applications 2024',
    images: [geology01, geology02, geology03],
    paragraphs: [
      'The National Center of GIS and Space Applications (NCGSA), in collaboration with its partner lab G-SAG at NCEG, University of Peshawar, successfully organized a two-day International Workshop on Geological Remote Sensing & Applications on June 5–6, 2024, at the Institute of Space Technology (IST), Islamabad. The workshop brought together over 40 professionals and scholars from academia and industry across Pakistan for an immersive learning experience.',
      'Expert facilitators from the Faculty of Geo-Information Science and Earth Observation (ITC), University of Twente, along with specialists from IST and G-SAG Lab, led expert lectures, real-world case studies, and hands-on exercises using actual datasets. Participants developed practical skills in geological remote sensing for exploration and mining applications.',
    ],
  },
  {
    year: '2024',
    title: 'National Space Symposium 2024',
    images: [symposium01, symposium02, symposium03],
    paragraphs: [
      'The National Space Symposium 2024, jointly organized by SUPARCO, the National Center of GIS and Space Applications (NCGSA), and the Institute of Space Technology (IST), brought together leading voices from government, academia, and industry to highlight the transformative power of space science and technology in shaping Pakistan’s socioeconomic future.',
      'The event was graced by Prof. Ahsan Iqbal, Federal Minister for Planning, Development & Special Initiatives, as Chief Guest. He inaugurated the NCGSA research facility, explored its laboratories, and reviewed projects in disaster management, agriculture, geo-forensics, satellite navigation, and small satellite development. A symbolic tree plantation reinforced the national commitment to sustainability and innovation.',
      'The Minister applauded NCGSA’s contribution to national development and urged a continued focus on applied, impact-driven research to build a knowledge-based, globally competitive economy.',
    ],
  },
  {
    year: '2023',
    title: 'First Workshop on General Relativity, Cosmology, Astrophysics & Particle Physics 2023',
    images: [relativity2301, relativity2302, relativity2303],
    paragraphs: [
      'The Space and Astrophysics Research Lab (SARL) of the National Center of GIS and Space Applications (NCGSA) organized a specialized Workshop on General Relativity, Cosmology, Astrophysics, and Particle Physics on November 28, 2023, at the Institute of Space Technology (IST), Islamabad.',
      'The workshop brought together students, researchers, and enthusiasts to explore fundamental questions of the universe, covering core concepts and recent advances in theoretical physics and astrophysics. Subject matter experts guided participants from the fabric of space-time to the physics of the early universe.',
    ],
  },
  {
    year: '2023',
    title: 'Summer School on Remote Sensing & GISc. 2023',
    images: [remote01, remote02, remote03],
    paragraphs: [
      'The National Center of GIS and Space Applications (NCGSA) successfully organized a five-day Summer School on Remote Sensing & Geographic Information Science (GISc.) from June 19–23, 2023, at the Institute of Space Technology (IST), Islamabad. The event was held in collaboration with the Deqing Association for Geospatial Information Professionals and the Belt and Road International Geospatial Information Training Center, China.',
      'The school brought together over 100 participants from academia and public and private organizations across Pakistan. Twenty-four national and international experts led interactive lectures and hands-on sessions in remote sensing, GIS, photogrammetry, GNSS, and AI/ML applications for agriculture, forestry, disaster management, geology, and water resource management.',
    ],
  },
  {
    year: '2023',
    title: 'Teachers’ Training Workshop on Space Education 2023',
    images: [teachers01, teachers02, teachers03],
    paragraphs: [
      'The Space Education and Research Lab (SERL) of the National Center of GIS and Space Applications (NCGSA) organized a three-day Teachers’ Training Workshop on Space Education from September 14–16, 2023, at the Institute of Space Technology (IST), Islamabad. The workshop was conducted in collaboration with the IAU Office of Astronomy for Education, an initiative of the International Astronomical Union.',
      'Designed for primary and secondary science teachers and aligned with Pakistan’s national space education curriculum, the workshop strengthened understanding of astronomy and space science while equipping educators with interactive tools, teaching strategies, and hands-on activities to inspire young learners.',
    ],
  },
  {
    year: '2023',
    title: 'APRSAF Space Education Seminar 2023',
    images: [aprsaf01, aprsaf02, aprsaf03],
    paragraphs: [
      'The Japan Aerospace Exploration Agency (JAXA), the Space Education & Awareness Drive (SEAD) of SUPARCO, and the Space Education and Research Lab (SERL) of NCGSA jointly organized the Asia-Pacific Regional Space Agency Forum Space Education Seminar on February 1, 2023, at the Institute of Space Technology (IST), Islamabad.',
      'More than 100 students and educators joined talks and hands-on activities led by experts from JAXA and NCGSA. The seminar introduced astronomy, space exploration, and science communication, concluding with a special stargazing session at the IST Astronomical Observatory in collaboration with the Astronomical Societies of Pakistan.',
    ],
  },
];

const EventSection = ({ event, index }) => {
  const [activeImage, setActiveImage] = useState(0);

  useEffect(() => {
    const timer = window.setInterval(
      () => setActiveImage((current) => (current + 1) % event.images.length),
      3000,
    );
    return () => window.clearInterval(timer);
  }, [event.images.length]);

  return (
    <section className={`capacity-event ${index % 2 ? 'capacity-event-grey' : ''}`}>
      <div className={`capacity-event-inner ${index % 2 ? 'capacity-event-reversed' : ''}`}>
        <div className="capacity-event-copy">
          <p className="section-eyebrow">CAPACITY IN ACTION · {event.year}</p>
          <h2>{event.title}</h2>
          <div className="capacity-title-line" aria-hidden="true" />
          {event.paragraphs.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
          {event.experts && (
            <div className="capacity-experts">
              <h3>Featured experts</h3>
              <ul>{event.experts.map((expert) => <li key={expert}>{expert}</li>)}</ul>
            </div>
          )}
        </div>
        <div className="capacity-event-gallery">
          <figure className="capacity-event-image">
            <img src={event.images[activeImage]} alt={`${event.title} gallery ${activeImage + 1}`} />
          </figure>
          <div className="capacity-slider-controls">
            <button type="button" onClick={() => setActiveImage((activeImage - 1 + event.images.length) % event.images.length)} aria-label={`Previous image from ${event.title}`}>←</button>
            <span>{String(activeImage + 1).padStart(2, '0')} / {String(event.images.length).padStart(2, '0')}</span>
            <button type="button" onClick={() => setActiveImage((activeImage + 1) % event.images.length)} aria-label={`Next image from ${event.title}`}>→</button>
          </div>
        </div>
      </div>
    </section>
  );
};

const CapacityBuildingEvents = () => (
  <div className="capacity-events" aria-label="Capacity building workshops and training events">
    {events.map((event, index) => <EventSection event={event} index={index} key={event.title} />)}
  </div>
);

export default CapacityBuildingEvents;
